import type { IStorageStrategy } from '@sine/sine-browser-storage';

const deviceTokenPropName = 'deviceToken';

export default class DeviceTokenService {
  private tokenPersistence: IStorageStrategy;

  constructor(tokenPersistence: IStorageStrategy) {
    this.tokenPersistence = tokenPersistence;
  }

  clearToken(): void {
    this.tokenPersistence.removeItem(deviceTokenPropName);
  }

  getToken(): string | null {
    return this.tokenPersistence.getItem(deviceTokenPropName);
  }

  setToken(token: string): void {
    return this.tokenPersistence.setItem(deviceTokenPropName, token);
  }
}
